import React, { Component } from 'react';
import { store } from './stores/mainStore';
import { observer } from 'mobx-react';

import { Main } from './components/Main';
import { CommandQueue } from './webview/CommandQueue'
import {Manager} from './game/manager';

@observer
class App extends Component {
	constructor(){
		super();
		window.store = store;
		if (process.env.NODE_ENV === 'production') {
		//if (process.env.NODE_ENV !== 'development') {
			console.log('******** ABOUT TO DISABLE CONSOLE.LOG ********');
			console.log = function() {};
			console.log('***** trying to log after disable.  IF YOU SEE THIS LOGGING IS ENABLED');
		}

		window.CommandQueue = new CommandQueue(window.CommandQueue);

		window.manager = null;
		window.manager = new Manager();
	}
	render() {
		return <Main/>
	}
}
export { App };
